import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import * as React from 'react';

import { cn } from '@heidi/utils';

import { useIsExperimentalDesignSystemForms } from '../hooks/use-is-experimental-design-system-forms';
import { checkboxRootClassesExperimental } from './checkbox.experimental.styles';
import {
  checkboxExpandedHitAreaClasses,
  checkboxIconClasses,
  checkboxIndicatorClasses,
  checkboxRootClasses,
} from './checkbox.styles';
import type { CheckboxProps, CheckboxRef } from './checkbox.types';

const Checkbox = React.forwardRef<CheckboxRef, CheckboxProps>(
  ({ className, expandHitArea = false, ...props }, ref) => {
    const isExperimentalForms = useIsExperimentalDesignSystemForms();
    const hitAreaClasses = expandHitArea ? checkboxExpandedHitAreaClasses : undefined;
    // Root only — the glyphs paint from `text-current`, so they follow it.
    const rootClasses = isExperimentalForms
      ? checkboxRootClassesExperimental
      : checkboxRootClasses;

    return (
      <CheckboxPrimitive.Root
        ref={ref}
        data-experimental={isExperimentalForms || undefined}
        className={cn(rootClasses, hitAreaClasses, className)}
        {...props}
      >
        <CheckboxPrimitive.Indicator
          // Keep both glyphs mounted so the entry/exit animations can fire on
          // `data-state` changes.
          forceMount
          className={checkboxIndicatorClasses}
        >
          <Check className={checkboxIconClasses.check} aria-hidden="true" />
          <Minus className={checkboxIconClasses.indeterminate} aria-hidden="true" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
    );
  }
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
